<template>
    <div class="featuredBlock">
        <p class="featuredBlock-title"> {{ handleBlockTitle }} </p>
        <p class="featuredBlock-content">
            {{ content }}
            <span v-show="catalogSrc(resumeData.modelid, 1) && showCatalog" class="featuredBlock-link">
                Download do catálogo <a :href="catalogSrc(resumeData.modelid, 'catalog')" target="_blank">aqui</a>
            </span>
        </p>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'FeaturedBlock',
        props:{
            secTitle: {type: String},
            content: {type: String},
            showCatalog: {type: Boolean, default: true},
        },
        inject:['page'],
        computed:{
            ...mapState(['resumeData']),
            ...mapGetters({
                catalogSrc: 'getPipContent',
            }),
            handleBlockTitle(){
                return (this.page != 'Resume') ? this.secTitle + ' ' + this.resumeData.model : this.secTitle ;
            },
        }
    }
</script>
<style lang="scss" scoped>
    .featuredBlock{
        margin: 4rem 0 2.5rem;

        &-title{
            @include mixin_textContent(1.125rem, 1.125rem, $medium, $grayDarkCol);
            margin-bottom: 1rem;
        }

        &-content{
            @include mixin_textContent(.875rem, 1.375rem, $regular, $grayLightCol);
        }

        &-link{
            @include mixin_textContent(.875rem, 1.375rem, $medium, $primaryCol);

            & > a{ font-family: $medium; }
        }
    }
</style>
